import React, {Component} from 'react'
import MainSettings from './MainSettings'
import Indicators from './Indicators'
import Time from './Time'

import style from './settings.sass'

class Settings extends Component {
  restore = () => {
    this.props.store.analysis.restore()
  }
  render() {
    return(
      <div styleName='wrapper'>

        <hr styleName='separator'/>

        <MainSettings/>

        <hr styleName='separator'/>

        <Indicators/>

        <hr styleName='separator'/>

        <Time/>
      </div>
    )
  }
}

export default Settings
